import {
  Component,
  DestroyRef,
  effect,
  inject,
  input,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { WizardSection } from '@app/models/project-setup.models';
import {
  FinancialAssetConnectionToProjectType,
  FinancialAssetType,
} from '@app/models/shared.enums';
import { WizardStore } from '@app/stores/project-setup/wizard.store';
import { GenericProjectStore } from '@app/stores/projects/generic-project.store';
import { Item } from '@app/ui-components/card-array/card-array.component';
import { CardComponent } from '@app/ui-components/card/card.component';
import { FormArrayCardComponent } from '@app/ui-components/form-array-card/form-array-card.component';
import { InfoLabelComponent } from '@app/ui-components/info-label/info-label.component';
import { ValidatedDatePickerComponent } from '@app/ui-components/validated-date-picker/validated-date-picker.component';
import { ValidatedDropdownComponent } from '@app/ui-components/validated-dropdown/validated-dropdown.component';
import { ValidatedNumberInputComponent } from '@app/ui-components/validated-number-input/validated-number-input.component';
import { ValidatedTextAreaComponent } from '@app/ui-components/validated-textarea/validated-textarea.component';
import { TranslateModule } from '@ngx-translate/core';
import { SectionDFormGroup } from '../+helpers/section-d-form.helper';
import { getFinancialAssetFormGroup } from '../../device-card/device-card-form.helper';
import { DeviceCardComponent } from '../../device-card/device-card.component';
import { getPersonContactCardFormGroup } from '../../person-contact-card/person-contact-form/person-contact-card-form.helper';
import { PersonContactFormComponent } from '../../person-contact-card/person-contact-form/person-contact-form.component';

@Component({
  selector: 'app-section-d',
  imports: [
    CardComponent,
    ValidatedNumberInputComponent,
    ValidatedDropdownComponent,
    ValidatedDatePickerComponent,
    ValidatedTextAreaComponent,
    DeviceCardComponent,
    ReactiveFormsModule,
    TranslateModule,
    InfoLabelComponent,
    FormArrayCardComponent,
    PersonContactFormComponent,
  ],
  templateUrl: './section-d.component.html',
  styleUrl: './section-d.component.scss',
})
export class SectionDComponent implements OnInit {
  wizardStore = inject(WizardStore);
  projectId = input.required<string>();
  stepDisabled = input<boolean>(false);
  genericProjectStore = inject(GenericProjectStore);
  protected formGroup = signal<FormGroup<SectionDFormGroup> | null>(null);
  protected translationKey = 'projectWizard.sectionDForm.';

  cardArrayItems: Item[] = [];
  constructor(private fb: FormBuilder, private destroyRef: DestroyRef) {
    effect(() => {
      const form = this.formGroup();
      const disabled = this.stepDisabled();
      if (form) {
        if (disabled) form.disable({ emitEvent: false });
        else form.enable({ emitEvent: false });
      }
    });
  }

  ngOnInit(): void {
    this.wizardStore
      .getSection(this.projectId(), WizardSection.D)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) =>
        this.formGroup.set(data as FormGroup<SectionDFormGroup>)
      );
  }

  protected removeGuarantor($event: number) {
    this.formGroup()!.controls.guarantors.removeAt($event);
  }

  protected addGuarantor() {
    this.formGroup()!.controls.guarantors.push(
      getPersonContactCardFormGroup(this.fb, false, 'KeszfizetoKezessegVallalo')
    );
  }

  protected removeDevice($event: number) {
    this.formGroup()!.controls.devices.removeAt($event);
  }

  protected addDevice() {
    this.formGroup()!.controls.devices.push(
      getFinancialAssetFormGroup(
        this.fb,
        FinancialAssetType.Bond,
        FinancialAssetConnectionToProjectType.ForNonOwnershipAssets
      )
    );
  }
}
